export const environment = {
  production: false,
  message: 'You are in DEVELOP',
  shopify: 'https://viny.club/',
  newsletter: 'https://viny.club/#newsletter',
  backUrl: 'https://api.viny.club',
  // backUrl: 'http://viny.docker',
};

export const stores = {
  appleStore: 'https://apps.apple.com/fr/app/viny-music/id',
  androidStore: 'https://play.google.com/store/apps/details?id=app.viny.com',
};

export const apiUrls = {
  login: `${environment.backUrl}/api/authentication_token`,
  register: `${environment.backUrl}/api/users`,
  refreshToken: `${environment.backUrl}/api/token/refresh`,
  getUser: `${environment.backUrl}/api/users/`,
  updateUser: `${environment.backUrl}/api/users/`,
  getVinyls: `${environment.backUrl}/api/vinyls`,
  getArtists: `${environment.backUrl}/api/artists`,
  images: `${environment.backUrl}/images/`,
  artistRequest: `${environment.backUrl}/api/artists/request`,
  myVinyls: `${environment.backUrl}/api/vinyls/my-vinyls`,
  myNewsVinyls: `${environment.backUrl}/api/vinyls/news`,
  myArtists: `${environment.backUrl}/api/artists/my-artists`,
  artist: `${environment.backUrl}/api/artists/`,
  post: `${environment.backUrl}/api/posts/`,
  vinyl: `${environment.backUrl}/api/vinyls/`,
  assetsApi: `${environment.backUrl}/images/`,
  songApi: `${environment.backUrl}/post/file/`,
  postsbyArtist: `${environment.backUrl}/api/posts/by/`,
  myPosts: `${environment.backUrl}/api/posts/my-posts`,
  vinylsbyArtist: `${environment.backUrl}/api/vinyls/by/`,
  checkQrcode: `${environment.backUrl}/api/qrcode/check/`,
  activateQrcode: `${environment.backUrl}/api/qrcode/activate`,
  subscribe: `${environment.backUrl}/api/artists/subscribe`,
};

export const apiKeys = {
  googleSignAndroid: '372832176019-6kfndqjinabf1m774kop1sh2c3klte7t.apps.googleusercontent.com',
};





